/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react'
import moment from 'moment'
import { sortByKey, getTimeStamp, formatTimeStamp, compareRecipeTime, totalMealValue } from 'lib/services';
import { put, post } from 'lib/api';
import RoutingConstants from 'lib/RoutingConstants'
import Loader from 'lib/loader';
import history from '../../history';
// import ViewSelectedRecipe from '../recipeList/ViewSelectedRecipe'


export const ShowRecipe = props =>{
  const { recipeArr, recipeIndex, disabled } = props
  const rcpLength = recipeIndex
  return(
    <div className="top-rcp-blk">
      <div className="row cls-icn">
        <span className="rcp-cls">
          <img src="/images/clos.svg" alt="" className="cross" onClick={()=>props.close()} />
        </span>
        <div className="rcp-dtl">          
          <img src={recipeArr[rcpLength].image} alt= "" />
          <div className="rcp-nm">
            <h3>{recipeArr[rcpLength].items.recipe.name}</h3>
            {recipeArr[rcpLength].sideName &&
              <span>
                <img src={recipeArr[rcpLength].equipmentIcon} alt="" />
                <p>{recipeArr[rcpLength].sideName}</p>
              </span>
            }
          </div>
        </div>
        <div className="rcp-tmpstmp">
          <span>
            <img src="/images/active_time.png" className="handsvg" alt=""/>
            <b>{recipeArr[rcpLength].totalHands} </b>
            <span>Active</span>
          </span>
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px"
              viewBox="0 0 100 100" style={{enableBackground:"new 0 0 100 100"}} xmlSpace="preserve">
              <g>
                <path d="M50,5C25.2,5,5,25.2,5,50s20.1,45,45,45s45-20.1,45-45S74.8,5,50,5z M50,89.7c-21.9,0-39.7-17.8-39.7-39.7   c0-21.9,17.8-39.7,39.7-39.7S89.7,28.1,89.7,50C89.7,71.9,71.9,89.7,50,89.7z" />
                <path d="M52.4,51.7V25.2c0-1.3-1.1-2.4-2.4-2.4s-2.4,1.1-2.4,2.4v27.3c0,0.3,0.1,0.6,0.1,0.8c0.1,0.4,0.3,0.8,0.6,1.1l19.3,19.3   c0.9,0.9,2.5,0.9,3.4,0c0.9-0.9,0.9-2.5,0-3.4L52.4,51.7z" />
              </g>
            </svg>
            <b> {recipeArr[rcpLength].totalTime}</b> 
            <span> Total Time</span>
          </span>
        </div>    
        <div className="save-btn">
          <button className="rcp-save" onClick={()=>props.saveRecipe()} disabled={disabled}> Save </button>
        </div>
      </div>
      <div className="prep-hdng">
        <b> Prep Plan </b>
        <span> Add the recipe to cooking schedule </span>
      </div>
    </div>
  )
}

export const ShowBundle = props =>{
  const { recipeArr, bundleItems, bundleStep, colorIndex, cookDayColorArr, recipeIndex } = props
  const headingText = bundleStep ? 'Step 1: Add this bundle to your prep plan' : 'Step 2 : Add recipes to your meal plan'
  const bundleClass = bundleStep ? 'bundle-rcp ad-bundle' : 'bundle-rcp ad-bundle sub-rcp'
  return(
    <div className="top-rcp-blk">
      <div className="row cls-icn">
        <div>
          <span className="rcp-cls">
            <img src="/images/clos.svg" alt="" className="cross" onClick={()=>props.close()} />
          </span>
          <h2> {headingText} </h2>
          <div className={bundleClass} key={bundleItems.bundleTitle}>
            <div className="bundle-hdng-left">
              {bundleStep ?
                <h4> 60min Bundle: {bundleItems.bundleTitle} </h4>
                :
                <h4> Select a recipe to highlight and then add it to your meal plan. </h4>
              }
            </div>
            <div className='cal-days-cntnt dishes-row'>
              {
                recipeArr.map((bunRcp,bunIndex)=>{
                  const item = bunRcp.items.recipe
                  const sideName = item.sideRecipe ? item.sideRecipe.name : null
                  const rcpBorder = colorIndex > -1 && (bunIndex === recipeIndex) ? `1.5px solid ${cookDayColorArr[colorIndex]}` : '0.5px solid rgba(151, 151, 151, 0.4)' 
                  return(
                    <div className="meal-post" key={`contentFulBundle${bunIndex}`} style={{border: rcpBorder}}>
                            
                      <div 
                        onClick={()=>props.selMealRcp(bunIndex)}
                      >
                        <a>
                          <div className="LazyLoad is-visible recipe_img" style={{height: '80px'}}><img src={item.recipeImage} className='' alt="" /></div>
                          
                          <div className="select-meals-title-cntnt">
                            <h5>{item.name}</h5>
                          </div>
                          <div className="meal-post-data">
                            <div className="meal-post-data-box meal-post-data-img">
                              <img
                                src={item.equipmentIcon}
                                className="equipment-icn"
                                alt="icon"
                              />
                              {sideName && <p className="aftr-hdng">{sideName}</p>}
                            </div>
                          </div>
                        </a>
                      </div>
                      
                    </div>
                          
                  )
                  // }
                  // return null;
                })
              }
              {bundleStep && <div className="bundle-time">
                <span> <b> Active: </b> {bundleItems.bundleHands} </span>
                <span> <b> Total Time: </b> {bundleItems.bundleTotalTime} </span>
              </div>}
            </div>
       
          </div>
          {/* ) */}
        </div>
        
        {bundleStep ? 
          <div className="save-btn">
            <button className="rcp-save" onClick={()=>props.nextBundleStep()}> Next </button>
          </div>
          :
          <div className="save-btn">
            <button className="bk-btn" onClick={()=>props.backBundleStep()}> <img src="/images/Back Arrow Small.png" alt="back" /> </button>
            <button className="rcp-save" onClick={()=>props.saveRecipe()}> Save </button>
          </div>
        }
      </div>
      <div className="prep-hdng">
        <b> Prep Plan </b>
        <span> Add the recipe to cooking schedule </span>
      </div>
    </div>
  )
}

class ViewSelectedRecipe extends Component {
  constructor(props) {
    super(props);
    const bundleStep = props.isBundle 
    
    this.state={
      ...props,
      disabled: true,
      visibleIndex: -1,
      cookDayColorArr:["#00C853","#6236FF","#FA6400","#32C5FF","#F7B500","#B620E0","#979797"],
      cookDayTime:[],
      showAll: [],
      meal: [],
      loadData: false,
      showDel: -1,
      cook: [],
      planIndex: -1,
      deletedCook:[],
      deletedMeal:[],
      params:{
        delete_cooking_recipe : [],
        delete_user_cooking_dates: [],
        user_weekly_schedule_id:props.inputs.user_weekly_schedule_id
      },
      bundleStep,
      colorIndex: -1,
      showRcpIndex: [],
      showBundleIndex: [],
    }
  }
  // eslint-disable-next-line
  setHeight(cookDay) {
    let bundle = 0
    let preBundle = 0
    let meal = 0
    let premeal = 0
    let preHeight = []
    cookDay.map((item)=>{
      if(item.recipe.length > 1) {
        bundle = 0
        meal = 0
        preBundle = 0
        item.recipe.map((rcp)=>{

          if(rcp.isBundle) {
            bundle += 1
          } else {
            meal +=1
          }
          // if(cIndex === 0) {
          preBundle = bundle
          premeal = meal
          // }
          return rcp;
        })
        const addBundle = preBundle > 0 ? preBundle * 60 : 0 
        const hei = (preBundle * 75)+(premeal*60) + addBundle + 75
        preHeight.push({height:`${hei}`})
        preHeight = preHeight.sort(sortByKey('height','desc'))
      }
      return item;
    })
    // const addBundle = preBundle > 0 ? preBundle * 60 : 0 
    const hData = preHeight[0] ? parseInt(preHeight[0].height,0) : 200
    return hData > 200 ? hData : 200 
  }

  hoverDay(index){
    this.setState({ visibleIndex:index })
  }

  addCookDay(dayDate, day,) {
    
    const { 
      recipeArr, mealArr, showAll, recipeIndex, inputs, servingSize, recipeIds, dayDates, deletedCook, params, isBundle, bundleItems,
      
    } = this.state
    let { cookDay, height } = this.state
    const bundleRecipe = []
    // console.log(bundleItems)
    const rcpLength = recipeIndex
    const recipe = !isBundle ? recipeArr[rcpLength].items.recipe : null
    const recipeId = !isBundle ? recipeArr[rcpLength].items.recipe.recipeId : bundleItems.recipeId  
    const recipeName = !isBundle ? recipeArr[rcpLength].items.recipe.name : `${bundleItems.bundleTitle}`
    const equipmentIcon = !isBundle ? recipeArr[rcpLength].equipmentIcon : null

    const cookIndex = cookDay.findIndex(x=>x.cooking_date === dayDate)
    const sideId = !isBundle && recipeArr[rcpLength].items.recipe.recipe_sides.length > 0 ? 
      recipeArr[rcpLength].items.recipe.recipe_sides[0].recipe.sideId: null ;
    if(!params.cooking_data) {
      params.cooking_data = []
    }

    if(isBundle) {
      recipeArr.map(bundleRcp=>{
        // const resBundleIndex = result.items.findIndex(x=>x.sys.id === bundleRcp.sys.id)
        // if(resBundleIndex > -/1) {
        bundleRecipe.push({name:bundleRcp.items.recipe.name,id:bundleRcp.id}) 
        // }
        return null
      })  
    }
    const type = isBundle ? 'bundle': 'meal'
    const idIndex = recipeIds.findIndex(x=>x.id === recipeId && x.type === type)
    if(idIndex > -1) {
      recipeIds[idIndex].count += 1
    } else {
      // const type = isBundle ? 'bundle' : 'meal'
      recipeIds.push({ id: recipeId, count : 1, type})
    }
    const cIndex = params.cooking_data.findIndex(x=>x.cooking_date === dayDate )
    if(cIndex > -1) {
      const rIndex = params.cooking_data[cIndex].recipes.findIndex(x=>x.recipe_id === recipeId)
      if(rIndex === -1 ) {
        params.cooking_data[cIndex].recipes.push({
          recipe_id: recipeId,
          side_dish_id: sideId,
          serving_size: servingSize,
          isBundle : isBundle ? 1 : 0
        })
      }
    } else {
      params.cooking_data.push({cooking_date: dayDate, recipes:[{
        recipe_id: recipeId,
        side_dish_id: sideId,
        serving_size: servingSize,
        isBundle : isBundle ? 1 : 0
      }]})
    }
    
    const delCookIndex = deletedCook.findIndex(x=>x.cook_date === dayDate)
    if(delCookIndex >-1) {
      const inDelCook = params.delete_user_cooking_dates.findIndex(x=>x=== deletedCook[delCookIndex].id)
      if(inDelCook > -1) {
        params.delete_user_cooking_dates.splice(inDelCook,1)
      }
    }

    if(cookIndex === -1) { 
      cookDay.push({ 
        cooking_date:dayDate, 
        cooking_day: day,
        recipe:[{
          name: recipeName,
          recipe,
          recipe_id: recipeId,
          activeTime: isBundle ? bundleItems.bundleHands: recipeArr[rcpLength].totalHands,
          totalTime: isBundle ? bundleItems.bundleTotalTime : recipeArr[rcpLength].totalTime,
          equipmentIcon,
          servingSize,
          side_dish_id: sideId,
          isBundle: isBundle ? 1 : 0,
          bundleRecipe
        }],
        
        totalTime:  isBundle ? bundleItems.bundleTotalTime :recipeArr[rcpLength].totalTime,
        totalHands: isBundle ? bundleItems.bundleHands : recipeArr[rcpLength].totalHands 
      })
      if(delCookIndex >-1) {
        cookDay[cookDay.length -1].cooking_id = deletedCook[delCookIndex].id 
      }
      
    } else if(cookIndex > -1){
      const rcpIndex = cookDay[cookIndex].recipe.findIndex(x=>x.recipe_id === recipeId)
      if(rcpIndex === -1 ){ 
        const rcpTotalTime = isBundle ? bundleItems.bundleTotalTime :recipeArr[rcpLength].totalTime
        const rcpTotalHands = isBundle ? bundleItems.bundleHands : recipeArr[rcpLength].totalHands 
        let totalHands = formatTimeStamp(cookDay[cookIndex].totalHands) + formatTimeStamp(rcpTotalHands)
        let totalTime = compareRecipeTime(formatTimeStamp(cookDay[cookIndex].totalTime) ,formatTimeStamp(rcpTotalTime))
        totalTime = compareRecipeTime(totalTime, totalHands)
        totalHands = getTimeStamp(totalHands)
        totalTime = getTimeStamp(totalTime)

        cookDay[cookIndex].recipe.push({
          name: recipeName,
          recipe,
          activeTime: isBundle ? bundleItems.bundleHands: recipeArr[rcpLength].totalHands,
          totalTime: isBundle ? bundleItems.bundleTotalTime : recipeArr[rcpLength].totalTime,
          recipe_id: recipeId,
          equipmentIcon,
          servingSize,
          side_dish_id:sideId,
          isBundle: isBundle ? 1 : 0,
          bundleRecipe
        })
        const showIndex = showAll.indexOf(cookIndex)
        if(showIndex === -1) {
          showAll.push(cookIndex)
        }
        cookDay[cookIndex].totalHands = totalHands
        cookDay[cookIndex].totalTime = totalTime
      }
    }
    // recipeArr[rcpLength].cooking_date = dayDate
    cookDay = cookDay.sort(sortByKey('cooking_date','asc'))
    height = this.setHeight(cookDay)
    const dayIndex = cookDay.findIndex(x=>x.cooking_date === dayDate)
    // let rcCount = 0   
    mealArr.map(mealType=>{
      mealType.recipe.map(item=>{
        let cookCount = 0
        item.cookDay = null
        item.cookIndex = null
        cookDay.map((cookdate,index)=>{
          // if(cookdate.recipe.length > 2)
          //   rcCount = 1 
          const bunIndex = cookdate.recipe.findIndex(x=>x.isBundle === 1)
          // const rId = bunIndex > -1 && item.isBundle === 1 ? cookdate.recipe[bunIndex].recipe_id: item.recipe_id
          let recpIndex = cookdate.recipe.findIndex(x=>x.recipe_id === item.recipe_id )
          // alert(rId)
          if(recpIndex > -1 && cookCount === 0 && item.isBundle === 0 ) {
            cookCount += 1;
            const startDate = moment(cookdate.cooking_date)
            const endDate = moment(item.meal_date)
            const result = endDate.diff(startDate,'days')
    
            if( result >= 0) {
              item.cookDay = cookdate.cooking_day
              item.cookIndex = index
            }
          } else if(recpIndex === -1 && item.isBundle === 1 && bunIndex > -1) {
            recpIndex = cookdate.recipe[bunIndex].bundleRecipe.findIndex(x=>x.id === item.recipe_id)
            if(recpIndex > -1 && cookCount === 0) {
              cookCount += 1;
              const startDate = moment(cookdate.cooking_date)
              const endDate = moment(item.meal_date)
              const result = endDate.diff(startDate,'days')
      
              if( result >= 0) {
                item.cookDay = cookdate.cooking_day
                item.cookIndex = index
              }}
          }
          return null;
        })
        return null;
      })
      return null;
    })
    // const showindex = cookIndex 
    // params.cooking_date = cookDay
    this.setState({ cookDay, recipeArr, height, showAll, showDel: `cook${dayIndex}${cookDay[dayIndex].recipe.length-1}`,
      disabled: false, inputs, recipeIds})
    window.analytics.track('Adding a recipe to the prep schedule', {
      startDate: `${dayDates[0].fullDay} ${dayDates[0].date}-${dayDates[0].Month}-${dayDates[0].Year}`,
      endDate: `${dayDates[6].fullDay} ${dayDates[6].date}-${dayDates[6].Month}-${dayDates[6].Year}`,
      cookingDate: dayDate,
      recipeName
    });
    setTimeout(()=>this.setState({ showDel: -1}), 1000)
  }

  saveRecipe() {
    this.setState({ loadData: true })
    const { cookDay, mealDay, mealArr, inputs, recipeIds, from, dayDates, params } = this.state
    let { height } = this.state
    height = height > 200 ? 250 : height
    const groceryData = []
    mealArr.map(item=>{
      item.recipe.map(rcp=>{
        // console.log(console.log(rcp.servingSize),'meal')
        if(rcp.recipe){
          rcp.recipe.recipeIngredient.map(value=>{
            let quantity = value.quantity;
            quantity *= (rcp.servingSize / 4);  
            value.unit = value.unit ? value.unit : null    
            const gIndex = groceryData.findIndex(x=>x.grocery_category_id === (value.ingredient.groceryId + 1) && x.ingredient_name === value.ingredient.name
            && x.measument_unit === value.unit)
            if(gIndex > -1) {
              groceryData[gIndex].ingredient_quantity += quantity 
            } else {
              groceryData.push({ 
                grocery_category_id : value.ingredient.groceryId + 1,
                ingredient_name : value.ingredient.name,
                ingredient_quantity :quantity,
                measument_unit: value.unit ? value.unit : null
              })
            }
            return null;
          })
        }
        if(rcp.recipe && rcp.recipe.sideRecipe) {
          // console.log(rcp.servingSize)
          rcp.recipe.sideRecipe.recipeIngredient.map(value=>{
            let quantity = value.quantity;
            quantity *= (rcp.servingSize / 4);      
            value.unit = value.unit ? value.unit : null
            const gIndex = groceryData.findIndex(x=>x.grocery_category_id === (value.ingredient.groceryId + 1) && x.ingredient_name === value.ingredient.name
            && x.measument_unit === value.unit)
            if(gIndex > -1) {
              groceryData[gIndex].ingredient_quantity += quantity 
            } else {
              groceryData.push({ 
                grocery_category_id : value.ingredient.groceryId + 1,
                ingredient_name : value.ingredient.name,
                ingredient_quantity :quantity,
                measument_unit: value.unit ? value.unit : null
              })
            }
            return null;
          })
        }
        return null;
      })
      return null;
    })
    // console.log(groceryData)

    const url = inputs.user_weekly_schedule_id  ? RoutingConstants.editNewPlan: RoutingConstants.addNewPlan
    let reqMethod ; 
    params.groceryData = groceryData
    params.week_start_date = inputs.week_start_date
    params.week_end_date = inputs.week_end_date
    if(inputs.user_weekly_schedule_id && inputs.user_weekly_schedule_id !== "") {
      params.user_weekly_schedule_id = inputs.user_weekly_schedule_id
      // params.user_weekly_schedule_id = inputs.user_weekly_schedule_id
      reqMethod = put(url, params) 
    } else{
      // delete inputs.user_weekly_schedule_id
      reqMethod = post(url, params) 
    }
    reqMethod.then(response=>{
      if(response.user_weekly_schedule_id){
        inputs.user_weekly_schedule_id = response.user_weekly_schedule_id
        params.user_weekly_schedule_id = response.user_weekly_schedule_id
      }
      if(response.data && response.data.cooking_schedule) {
        response.data.cooking_schedule.map(item=>{
          const cookIndex = cookDay.findIndex(x=>x.cooking_date === item.cooking_date)
          if(cookIndex>-1){
            item.recipe.map(rcp=>{
              const rcpIndex = cookDay[cookIndex].recipe.findIndex(x=>x.recipe_id === rcp.recipe_id)
              if(rcpIndex > -1) {
                cookDay[cookIndex].recipe[rcpIndex].id = rcp.id
                if(!cookDay[cookIndex].cooking_id)
                  cookDay[cookIndex].cooking_id = rcp.user_cooking_date_id
              }
              return rcp
            })
          }
          return item
        })
      }
      console.log(cookDay)
      if(response.data && response.data.meal_plan) {
        const responseRcp = response.data.meal_plan
        mealArr.map(item=>{
          item.recipe.map(rcp=>{
            const resIndex = responseRcp.findIndex(x=>x.cooking_date === rcp.meal_date)
            if(resIndex >-1) {
              console.log(resIndex,'1')
              const mealIndex = responseRcp[resIndex].recipe.findIndex(x=>x.meal_plan_date === rcp.meal_date 
                && x.meal_plan_type === item.type && x.recipe_id === rcp.recipe_id )
              if(mealIndex > -1) {
                rcp.id = responseRcp[resIndex].recipe[mealIndex].id
              }
            }
            return rcp;
          })
          return item;
        })
      }
      this.setState({ loadData: false, groceryData: []})
      
      if(from === 'addSingle') {
        history.push('/dashboard',{ dayDates})
      } else
        this.props.saveRecipe(cookDay, mealDay, mealArr, height, recipeIds, inputs)
      console.log(response)
    }).catch(err=>{
      this.setState({ loadData: false})
      console.log(err)
    })
  }


  showAllCook(cookIndex) {
    const { showAll,cookDay } = this.state
    let { height } = this.state
    // height = cookDay[cookIndex].recipe.length > 2 ? 200 + ((cookDay[cookIndex].recipe.length - 1) * 40) : height
    // let height = this.state.height
    height = this.setHeight(cookDay)
    showAll.push(cookIndex); 
    this.setState({ showAll, height })
  }

  cookSchdule() {
    const { dayDates, visibleIndex, cookDay, cookDayColorArr, height, isBundle, bundleStep } = this.state
    const tDate = moment().format('DD-MM-YYYY')
    const btnClass = cookDay.length === 0 ? 'show cook-day' : 'hover cook-day'
    let colorIndex = -1
    const cookText = isBundle ? 'prep' : 'cook'
    let h = 338
    // alert(h)
    // alert(document.getElementsByClassName('vw-slc-rcp')[0].offsetHeight)
    if(document.getElementsByClassName('vw-slc-rcp')[0] && document.getElementsByClassName('top-rcp-blk')[0]  ) {
      h = document.getElementsByClassName('vw-slc-rcp')[0].offsetHeight -  document.getElementsByClassName('top-rcp-blk')[0].offsetHeight -109
    }
    const subHeight = isBundle ? h : height
    return(
      dayDates.map((day, index)=>{
        let cDateClass = "bold-cDate"
        let dayClass = ""
        const activeDate = `${day.date}-${day.Month}-${day.Year}`
        const dayDate = `${day.Year}-${day.Month}-${day.date}`
        const cookIndex = cookDay.findIndex(x=>x.cooking_date === dayDate )
        if(activeDate === tDate) {
          cDateClass = "bold-cDate active"
          dayClass = "active"
        } 
        const hoverIndex = isBundle ? (bundleStep ? index : -1) : index 
        console.log(isBundle,bundleStep, hoverIndex)
        colorIndex = cookIndex > -1 ? colorIndex + 1 : colorIndex
        const brdrClass = index === 0 ? "no-brdr": ""
        return(
          <div className="day-range" key={activeDate}>
            <span className={dayClass}>{day.day}</span>
            <span className={`cDate-cls ${brdrClass}`}>
              <span className={cDateClass}>{day.date}</span>
            </span>
            {cookIndex === -1 && 
              <span className={`prep-add-hdng ${brdrClass}`}>
                <span style={{visibility:visibleIndex === index ? 'visible': 'hidden'}}>Click + to add prep day </span>
              </span>
            }
            { cookDay.length > 0 && cookIndex > -1 && 
              <div className="ttl_dtime">
                <span> <b> {cookDay[cookIndex].totalHands} </b> Active </span>
                <span className="seprtr"> <i className="fa fa-circle" /> </span>
                <span> <b> {cookDay[cookIndex].totalTime} </b> Total </span>
                <span className="time_brdr" style={{ borderBottom: `4px solid ${cookDayColorArr[colorIndex]}`}}/>
              </div>
            }
            <div className={`cook-sch-cls ${brdrClass}`} style={{ height: `${subHeight}px`}}>
              { index === 0 && <span className="side-rcp-hdng">{cookText} schedule</span> }
              {
                cookIndex > -1 && 
                  this.cookMealRecipe(cookIndex)
              }
              <button className={btnClass} onMouseOver={()=>this.hoverDay(index)} onMouseOut={()=>this.hoverDay(-1)} 
                onClick={()=>this.addCookDay(dayDate, day.day, index)}>
                <img src="/images/add-small.svg" alt=""/>
                <span>Cook Day</span>
              </button>
            </div>
          </div>
        )
      })
    )
  }

  cookMealRecipe(index) {
    const { cookDay, showAll, showDel, showBundleIndex, isBundle, bundleStep } = this.state
    const showCookDIndex = showAll.indexOf(index)
    const showIndex = showCookDIndex > -1 && cookDay[index].recipe.length > 3 ? cookDay[index].recipe.length - 1 : 2 
    // const subRecipe = !isBundle ? null : 
    return(
      <div className="cook-sch" key={index}>
        {
          cookDay[index].recipe.map((item, cIndex)=>{
            const hoverIndex = isBundle ? (bundleStep ? 0 : -1) : 0 
            const name = item.isBundle === 0 ? item.name : `Bundle: ${item.name}`
            const showBundle = !isBundle ? true : bundleStep || showBundleIndex.findIndex(x=>x.id === `${index}${cIndex}`) > - 1  
            return(
              <div key={`${cookDay[index].cooking_day}${cIndex}`}>
                {showIndex >= cIndex ?
                  <div key={cIndex} className="cook-rcp-data" onClick={(event)=>this.clickRecipe(event,index,cIndex,item.recipe_id, item.isBundle)}>
                    <h4>{name}</h4>
                    <div className="rcp-tmp">
                      {item.equipmentIcon !=null && <span><img src={item.equipmentIcon} alt="icn"/> </span>}
                      <span>{item.activeTime} Active</span>
                      <span> <i className="fa fa-circle"/> </span>
                      <span>{item.totalTime} Total</span>
                    </div>
                    {
                      item.isBundle === 1 && showBundle &&
                    <div className="subRecipe">
                      <ul style={{borderTop: !isBundle ? '0px' : bundleStep ?'1px solid #D8D8D8': '0px'}}>
                        {
                          item.bundleRecipe.map(rcp=>
                            (
                              <li key={rcp.id}> {rcp.name} </li> 
                            )
                          )
                        }
                      </ul>
                    </div>
                    }
                    { showDel!==`cook${index}${cIndex}` && hoverIndex > -1 && <div className="del-ml-rcp"><img src="/images/del.svg" alt="delete" onClick={()=>this.removeCook(index,cIndex)}/></div> }
                  </div>
                  :
                  cIndex === 3 &&
                <span onClick={()=> this.showAllCook(index)} className="more-rcp"> 
                  +{cookDay[index].recipe.length - 3} More</span>  
                }
              </div>
            )})
        }
      </div>
    )
  }

  addMeal(mealIndex, dayDate){
    const { recipeArr, mealArr, cookDay, recipeIndex, inputs, servingSize, recipeIds, dayDates, params, isBundle, bundleItems } = this.state
    const rcpLength = recipeIndex
    let cookCount = 0;
    let cookDayIndex = null
    let cookIndex = -1 
    const rId = isBundle ? bundleItems.recipeId: recipeArr[rcpLength].items.recipe.recipeId

    const sideId = recipeArr[rcpLength].items.recipe.recipe_sides.length > 0 ? 
      recipeArr[rcpLength].items.recipe.recipe_sides[0].recipe.sideId: null ;
    if(!params.meal_plan_data) {
      params.meal_plan_data = []
    }

    const type = isBundle ? 'mealbundle' : 'meal'
    const idIndex = recipeIds.findIndex(x=>x.id === recipeArr[rcpLength].items.recipe.recipeId && x.type === type)
    if(idIndex > -1) {
      recipeIds[idIndex].count += 1
    } else {

      recipeIds.push({ id: recipeArr[rcpLength].items.recipe.recipeId, count : 1, type})
    }

    const inIndex = params.meal_plan_data.findIndex(x=>x.meal_plan_date === dayDate)
    if(inIndex > -1) {
      params.meal_plan_data[inIndex].recipes.push({ 
        recipe_id: recipeArr[rcpLength].items.recipe.recipeId,
        serving_size: servingSize,
        side_dish_id: sideId,
        meal_plan_type: mealArr[mealIndex].type ,
        isBundle: isBundle ? 1 : 0
      })
    } else {
      params.meal_plan_data.push({ 
        meal_plan_date:dayDate,
        recipes:[{
          recipe_id: recipeArr[rcpLength].items.recipe.recipeId,
          serving_size: servingSize,
          side_dish_id: sideId,
          meal_plan_type: mealArr[mealIndex].type,
          isBundle: isBundle ? 1 : 0,
        }]
      })
    }

    cookDay.map((cookdate,index)=>{
      // const rId = cookdate.isBundle === 1 ? bundleItems.recipeId: item.recipe_id
      // const bunIndex = cookdate.recipe.findIndex(x=>x.isBundle === rcp.isBundle)
      // if(rcp.isBundle === )
      let rcpIndex = cookdate.recipe.findIndex(x=>x.recipe_id === rId )
      const bunIndex = cookdate.recipe.findIndex(x=>x.isBundle === 1)
      if(rcpIndex === -1) {
        if(bunIndex > -1 && isBundle === 1) {
          rcpIndex = cookdate.recipe[bunIndex].bundleRecipe.findIndex(x=>x.id === rId)
          if(rcpIndex > -1 && cookCount === 0 ) {
            cookCount += 1;
            cookDayIndex = cookdate.cooking_day
            cookIndex = index
          }
        }
      }
      else if(rcpIndex > -1 && cookCount === 0 ) {
        cookCount += 1;
        cookDayIndex = cookdate.cooking_day
        cookIndex = index
      }
      return null;
    })
    
    // cookDay.map((cookdate,index)=>{
    //   // const rId = isBundle ? bundleItems.recipeId: recipeArr[rcpLength].items.recipe.recipeId
    //   const rcpIndex = cookdate.recipe.findIndex(x=>x.recipe_id === rId )
    //   if(rcpIndex > -1 && cookCount === 0 ) {
    //     cookCount += 1;
    //     cookDayIndex = cookdate.cooking_day
    //     cookIndex = index
    //   }
    //   // alert(index)
    //   return null;
    // })
    let result = -1
    if(cookDay[cookIndex]){
      const startDate = moment(cookDay[cookIndex].cooking_date)
      const endDate = moment(dayDate)
      result = endDate.diff(startDate,'days')
    }
    // mealArr[mealIndex].recipe = mealArr[mealIndex].recipe
    mealArr[mealIndex].recipe.push({
      name: recipeArr[rcpLength].items.recipe.name,
      recipe:recipeArr[rcpLength].items.recipe,
      sideName: recipeArr[rcpLength].sideName,
      recipe_id: recipeArr[rcpLength].items.recipe.recipeId,
      meal_date: dayDate,
      image: recipeArr[rcpLength].image,
      cookDay: result >=0 ?  cookDayIndex: null,
      cookIndex: result >=0 ? cookIndex : null,
      servingSize,
      isBundle: isBundle ? 1 : 0,
    })

    window.analytics.track('Adding a recipe to the meal plan', {
      startDate: `${dayDates[0].fullDay} ${dayDates[0].date}-${dayDates[0].Month}-${dayDates[0].Year}`,
      endDate: `${dayDates[6].fullDay} ${dayDates[6].date}-${dayDates[6].Month}-${dayDates[6].Year}`,
      mealPlanDate: dayDate,
      recipeName: recipeArr[rcpLength].items.recipe.name
    });

    this.setState({ mealArr, showDel:`meal${mealIndex}${mealArr[mealIndex].recipe.length-1}`, disabled: false, inputs, recipeIds})
    setTimeout(()=>this.setState({ showDel: -1}),1000)
  }

  mealRcp(mealIndex, rcpIndex, planIndex) {
    const { mealArr, cookDayColorArr, showDel } = this.state
    const sideClass = mealArr[mealIndex].recipe[rcpIndex].sideName ? 'sidenm half-wdt' : 'sidenm full-wdt' 
    const cookClass = mealArr[mealIndex].recipe[rcpIndex].sideName ? 'meal-cook-day with-side' : 'meal-cook-day without-side' 
    return(
      <div className="meal-rcp">
        <span>
          <img src={mealArr[mealIndex].recipe[rcpIndex].image} alt=""/>
        </span>
        <div className="meal-rcp-nm">
          <h5>{mealArr[mealIndex].recipe[rcpIndex].name}</h5>
          <span className="rcp-info">
            { mealArr[mealIndex].recipe[rcpIndex].sideName && 
              <span className={sideClass}> {mealArr[mealIndex].recipe[rcpIndex].sideName} </span>
            }
            {mealArr[mealIndex].recipe[rcpIndex].cookDay && 
              <span className={cookClass} style={{ color: `${cookDayColorArr[mealArr[mealIndex].recipe[rcpIndex].cookIndex]}` }}>
                {mealArr[mealIndex].recipe[rcpIndex].cookDay}
              </span>
            }
          </span>
        </div>
        { showDel!== `meal${mealIndex}${rcpIndex}` && <div className="del-ml-rcp"><img src="/images/del.svg" alt="delete" onClick={()=>this.removeMeal(mealIndex,rcpIndex, planIndex)}/></div> }
      </div>
    )
  }

  removeMeal(mealIndex, rcpIndex, planIndex) {
    const { mealArr, recipeIds, dayDates, params } = this.state
    if(!params.meal_plan_data) {
      params.meal_plan_data = []
    }
    const mIndex = params.meal_plan_data.findIndex(x=>x.meal_plan_date === mealArr[mealIndex].recipe[rcpIndex].meal_date )
    if(mealArr[mealIndex].recipe[rcpIndex].id && params.update_meal_schedule){
      const updateMIndex = params.update_meal_schedule.findIndex(x=>x.id === mealArr[mealIndex].recipe[rcpIndex].id)
      if(updateMIndex > -1) {
        params.update_meal_schedule.splice(updateMIndex,1)
      }
    }
    
    if(mIndex > -1) {
      const rIndex = params.meal_plan_data[mIndex].recipes.findIndex(x=>x.recipe_id === mealArr[mealIndex].recipe[rcpIndex].recipe_id
        && x.meal_plan_type === mealArr[mealIndex].type )
      if(rIndex > -1) { 
        params.meal_plan_data[mIndex].recipes.splice(rIndex, 1)
      } 
      if(!params.meal_plan_data[mIndex].recipes) {
        params.meal_plan_data.splice(mIndex,1)
      }
    }
    if(!params.delete_meal_plan_schedule) {
      params.delete_meal_plan_schedule = []
    }
    if(mealArr[mealIndex].recipe[rcpIndex].id) {
      params.delete_meal_plan_schedule.push(mealArr[mealIndex].recipe[rcpIndex].id)
    }
    const type = mealArr[mealIndex].recipe[rcpIndex].isBundle === 0 ? 'meal' : 'mealbundle'
    const idIndex = recipeIds.findIndex(x=>x.id === mealArr[mealIndex].recipe[rcpIndex].recipe_id && x.type === type)
    if(idIndex > -1) {
      recipeIds[idIndex].count -= 1
      // recipeIds[idIndex].count -= 1
      if(recipeIds[idIndex].count === 0) {
        recipeIds.splice(idIndex,1)
      }
    } 

    window.analytics.track('Deleting a recipe to the meal plan', {
      startDate: `${dayDates[0].fullDay} ${dayDates[0].date}-${dayDates[0].Month}-${dayDates[0].Year}`,
      endDate: `${dayDates[6].fullDay} ${dayDates[6].date}-${dayDates[6].Month}-${dayDates[6].Year}`,
      mealPlanDate: mealArr[mealIndex].recipe[rcpIndex].meal_date,
      mealPlanType: mealArr[mealIndex].type,
      recipeName: mealArr[mealIndex].recipe[rcpIndex].name
    });

    mealArr[mealIndex].recipe.splice(rcpIndex,1)
    planIndex = `${mealIndex}${planIndex}`
    this.setState({ mealArr, notShow: rcpIndex, planIndex, disabled: false, recipeIds })
    setTimeout(()=>this.setState({ planIndex:-1}),2000)
  }

  removeCook(cookIndex, rcpIndex) {
    let { cookDay, height } = this.state
    const { mealArr, params, recipeIds, dayDates, deletedCook} = this.state
    const totalHands = formatTimeStamp(cookDay[cookIndex].totalHands) - formatTimeStamp(cookDay[cookIndex].recipe[rcpIndex].activeTime)
  
    let totalTime = 0
    if(!params.cooking_data) {
      params.cooking_data = []
    }

    const type = cookDay[cookIndex].recipe[rcpIndex].isBundle === 0 ? 'meal' : 'bundle'
    const idIndex = recipeIds.findIndex(x=>x.id === cookDay[cookIndex].recipe[rcpIndex].recipe_id && x.type === type)
    if(idIndex > -1) {
      recipeIds[idIndex].count -= 1
      if(type === 'bundle') {
        recipeIds.map((item,resInd)=>{
          const rInd = cookDay[cookIndex].recipe[rcpIndex].bundleRecipe.findIndex(x=>x.id === item.id) 
          if(rInd > -1) {
            mealArr.map(meal=>{
              const notBunIndex = recipeIds.findIndex(x=>x.id === item.id && x.type === 'meal')
              const mIndex = meal.recipe.findIndex(x=>x.recipe_id === item.id && x.isBundle === 1)
              if(mIndex > -1 ) {
                meal.recipe[mIndex].isBundle = 0
                if(notBunIndex === -1){
                  item.type = 'meal'
                } else {
                  recipeIds.splice(resInd,0)
                  recipeIds[notBunIndex].count += 1
                }
                if(meal.recipe[mIndex].id) {
                  let sideDishId = null
                  if(meal.recipe[mIndex].recipe.sideRecipe) {
                    sideDishId = meal.recipe[mIndex].recipe.sideRecipe.recipe_id
                    
                  }
                  if(!params.update_meal_schedule) {
                    params.update_meal_schedule = []
                  }
                  const updateIndex = params.update_meal_schedule.findIndex(x=>x.id === meal.recipe[mIndex].id)
                  if(updateIndex === -1)
                    params.update_meal_schedule.push({
                      id: meal.recipe[mIndex].id,
                      recipe_id: meal.recipe[mIndex].recipe_id,
                      side_dish_id: sideDishId,
                      serving_size: meal.recipe[mIndex].servingSize,
                      isBundle : 0
                    })
                } else {
                  params.meal_plan_data[mIndex].recipes.isBundle = 0
                }
              }
              return meal
            })
          }
          return null
        })
      }
      if(recipeIds[idIndex].count === 0) {
        recipeIds.splice(idIndex,1)
      }
    } 

    const cIndex = params.cooking_data.findIndex( x=> x.cooking_date === cookDay[cookIndex].cooking_date)
    if( cIndex > -1) {
      const rcpInd = params.cooking_data[cIndex].recipes.findIndex( x=>x.recipe_id === cookDay[cookIndex].recipe.recipe_id )
      if(rcpInd > -1) {
        params.cooking_data[cIndex].recipes.splice(rcpInd,1)
      }
      if(params.cooking_data[cIndex].recipes && params.cooking_data[cIndex].recipes.length > 0) {
        params.cooking_data.splice(cIndex,1)
      }
    }
   

    window.analytics.track('Deleting a recipe to the prep plan', {
      startDate: `${dayDates[0].fullDay} ${dayDates[0].date}-${dayDates[0].Month}-${dayDates[0].Year}`,
      endDate: `${dayDates[6].fullDay} ${dayDates[6].date}-${dayDates[6].Month}-${dayDates[6].Year}`,
      cookingDate: cookDay[cookIndex].cooking_date ,
      recipeName: cookDay[cookIndex].recipe[rcpIndex].name
    });


    if(cookDay[cookIndex].recipe[rcpIndex].id)
      params.delete_cooking_recipe.push(cookDay[cookIndex].recipe[rcpIndex].id)
    cookDay[cookIndex].recipe.splice(rcpIndex,1);
    if(cookDay[cookIndex].cooking_id && cookDay[cookIndex].recipe.length === 0){
      params.delete_user_cooking_dates.push(cookDay[cookIndex].cooking_id)
      deletedCook.push({cook_date:cookDay[cookIndex].cooking_date, id:cookDay[cookIndex].cooking_id})
    }

    cookDay[cookIndex].recipe.map(item=>{
      totalTime = compareRecipeTime(formatTimeStamp(item.totalTime), totalTime)
      return null
    })

    totalTime = compareRecipeTime(totalTime, totalHands)
    
    cookDay[cookIndex].totalHands = getTimeStamp(totalHands)
    cookDay[cookIndex].totalTime = getTimeStamp(totalTime)
        

    if(cookDay[cookIndex].recipe.length === 0) {
      cookDay.splice(cookIndex,1)
    }
    cookDay = cookDay.sort(sortByKey('cooking_date','asc'))
    
    // let rcCount = 0
    mealArr.map(mealType=>{
      mealType.recipe.map(item=>{
        let cookCount = 0
        item.cookDay = null
        item.cookIndex = null
        cookDay.map((cookdate,index)=>{

          const bunIndex = cookdate.recipe.findIndex(x=>x.isBundle === item.isBundle)
          const rId = bunIndex > -1 && item.isBundle === 1 ? cookdate.recipe[bunIndex].recipe_id: item.recipe_id
          const recpIndex = cookdate.recipe.findIndex(x=>x.recipe_id === rId )
          if(recpIndex > -1 && cookCount === 0 ) {
            cookCount += 1;
            const startDate = moment(cookdate.cooking_date)
            const endDate = moment(item.meal_date)
            const result = endDate.diff(startDate,'days')
    
            if( result >= 0) {
              item.cookDay = cookdate.cooking_day
              item.cookIndex = index
            }
          }
          return null;
        })
        return null;
      })
      return null;
    })
    height = this.setHeight(cookDay)
    this.setState({ cookDay, mealArr, disabled: false, height, recipeIds, deletedCook, params })
  }

  nextBundleStep() {
    const { bundleItems, cookDay } = this.state
    let colorIndex = -1
    let cookCount = 0
    cookDay.map((cookdate,index)=>{
      const recpIndex = cookdate.recipe.findIndex(x=>x.recipe_id === bundleItems.recipeId)
      if((recpIndex > -1) && (cookCount === 0) ) {
        cookCount += 1;
        colorIndex = index
      }
      return null;
    })
    this.setState({ bundleStep: false, recipeIndex: 0, colorIndex, height:70 })
  }
  
  backBundleStep() {
    this.setState({ bundleStep: true, recipeIndex: -1, colorIndex: -1, })
  }

  selMealRcp(bunIndex) {
    const { bundleStep, cookDay, bundleItems } = this.state
    let colorIndex = -1
    if(!bundleStep){
      let cookCount = 0
      cookDay.map((cookdate,index)=>{
        const recpIndex = cookdate.recipe.findIndex(x=>x.recipe_id === bundleItems.recipeId )
        if((recpIndex > -1) && (cookCount === 0) ) {
          cookCount += 1;
          colorIndex = index
        }
        return null;
      })
      this.setState({ recipeIndex: bunIndex, colorIndex})
    }
  }

  bundleCookSchdule() {
    const { dayDates, cookDay, showRcpIndex, cookDayColorArr, height } = this.state
    // let { height } =this.state
    const tDate = moment().format('DD-MM-YYYY')
    // const btnClass = cookDay.length === 0 ? 'show cook-day' : 'hover cook-day'
    let colorIndex = -1
    
    return(
      dayDates.map((day, index)=>{
        let cDateClass = "bold-cDate"
        let dayClass = ""
        const activeDate = `${day.date}-${day.Month}-${day.Year}`
        const dayDate = `${day.Year}-${day.Month}-${day.date}`
        const cookIndex = cookDay.findIndex(x=>x.cooking_date === dayDate )
        if(activeDate === tDate) {
          cDateClass = "bold-cDate active"
          dayClass = "active"
        } 
        colorIndex = cookIndex > -1 ? colorIndex + 1 : colorIndex
        const brdrClass = index === 0 ? "no-brdr": ""
        const totalMeal = cookIndex > -1 ? totalMealValue(cookDay[cookIndex].recipe,'isBundle',0) : 0
        const bundleLength = cookIndex > -1 && cookDay[cookIndex].recipe.length - totalMeal
        const rcpText = cookIndex > -1 && cookDay[cookIndex].recipe.length > 1 ? 'Recipes' : 'Recipe'
        const bundleText = cookIndex > -1 && bundleLength > 1 ? 'Bundles' : 'Bundle'
        
        return(
          <div className="day-range" key={activeDate}>
            <span className={dayClass}>{day.day}</span>
            <span className={`cDate-cls ${brdrClass}`}>
              <span className={cDateClass}>{day.date}</span>
            </span>
            <div className={`cook-sch-cls ${brdrClass}`} style={{ height: `${height}px`}}>
              { index === 0 && <span className="side-rcp-hdng cook">prep schedule</span> }
              {
                cookIndex > -1 &&
                <div className="cookMealRcp">
                  <span className="headr-brd mb-hide" style={{borderLeft: `4px solid ${cookDayColorArr[cookIndex]}`}}/>
                  { cookDay[cookIndex].recipe.length > 0 &&
                    <div className="cook-sch-rcp">
                      <h4> {cookDay[cookIndex].totalHands} Active </h4>
                      <div className="meal-typ">
                        <span>
                          {bundleLength > 0 && <span> {bundleLength} {bundleText} </span>}
                          {totalMeal > 0 && bundleLength > 0 && <span> <i className="fa fa-circle"/> </span>}
                          {totalMeal > 0 && <span> &nbsp;{totalMeal} {rcpText} </span>}
                        </span>
                        {showRcpIndex.findIndex(x=>x.index === cookIndex) === -1  ?
                          <span onClick={(event)=> this.expandData(event,cookIndex)} className="expand"> Show <i className="fa fa-angle-down" /> </span>
                          :
                          <span onClick={(event)=> this.expandData(event,cookIndex)} className="expand"> Collapse <i className="fa fa-angle-up" /> </span>
                        }
                      </div>
                    </div>
                  } 
                  {showRcpIndex.findIndex(x=>x.index === cookIndex) > -1  && this.cookMealRecipe(cookIndex)}
                </div>
              }
            </div>
          </div>
        )
      })
    )
  }

  expandData(event,cookIndex) {
    event.stopPropagation()
    const { cookDay, showBundleIndex } = this.state
    let { height, showRcpIndex } = this.state
    const index = showRcpIndex.findIndex(x=> x.index===cookIndex)
    if(index > -1) {
      showRcpIndex.splice(index,1)
      showBundleIndex.map((bunData,bunIndex)=>{
        if(bunData.cookIndex === cookIndex) {
          showBundleIndex.splice(bunIndex,1)
        }
        // const showBunIndex = showBundleIndex.findIndex(x=>x.cookIndex === cookIndex)
        // if(showBunIndex === -1) {
        //   height
        // }
        return null
      })
      
    } else {
      showRcpIndex.push({index:cookIndex, length: `${cookDay[cookIndex].recipe.length}`})
    }
    showRcpIndex = showRcpIndex.sort(sortByKey('length','desc'))
    if(showRcpIndex[0]){
      if(height < ((showRcpIndex[0].length*50 )+75))
        height = (showRcpIndex[0].length*50 )+75}
    if((showRcpIndex.length === 0)) {
      height = 70
    }
    this.setState({ showRcpIndex, height, rId: -1, rSelIndex: -1 })
  }

  clickRecipe(event,index,cIndex,rId, rcpBundle) {
    event.stopPropagation();
    const { rSelIndex, showBundleIndex, cookDay, showRcpIndex, isBundle } = this.state
    let bunIndex = -1
    // const totalMeal = totalMealValue(cookDay[index].recipe,'isBundle',0)
    // const bundleData = cookDay[index].recipe.length - totalMeal
    if(rcpBundle === 1){
      let { height } = this.state
      bunIndex = showBundleIndex.findIndex(x=>x.id=== `${index}${cIndex}`)
      if(bunIndex === -1) {
        showBundleIndex.push({id:`${index}${cIndex}`, cookIndex: index})
        const totalBundle = totalMealValue(showBundleIndex,'cookIndex',index)
        if(isBundle && index > -1 && cookDay[index])
          height = (cookDay[index].recipe.length*50 )+75+(totalBundle*70)
        this.setState({ height})
      }
    }
    if(rSelIndex !== `${index}${cIndex}`)
      this.setState({rSelIndex: `${index}${cIndex}`, rId, cookIndex: index, showBundleIndex})
    else {
      let { height } = this.state
      if(bunIndex > -1) {
        showBundleIndex.splice(bunIndex,1)
        const totalBundle = totalMealValue(showBundleIndex,'cookIndex',index)
        if((isBundle && showRcpIndex[0]) && height > ((showRcpIndex[0].length*50) +75+(totalBundle*70)))
          height -=75
      } 
      this.setState({ rSelIndex: -1, rId: -1, cookIndex:-1 })
    }
  }

  render() {
    const { dayDates, mealArr, mode, planIndex, loadData, isBundle, bundleStep, recipeIndex, recipeArr } = this.state
    const mealText = isBundle ? 'Step 2: Add recipes to the' : null
    const hoverIndex = isBundle ? (bundleStep ? 0 : -1) : 0 
    const rcpClass = hoverIndex === -1 ? 'rcp-sel' : bundleStep ? 'view-rcp min-hght' : 'view-rcp'
    
    return(
      <div className={rcpClass}>
        <div className="vw-slc-rcp">
          {
            loadData &&
          <div className="loading">
            <Loader />
            <div className="modal-backdrop fade in" />
          </div>
          }
          {!isBundle ?
            <ShowRecipe 
              {...this.state} 
              close={()=>this.props.onClose(mode,recipeArr[recipeIndex].calories)}
              saveRecipe={()=>this.saveRecipe()}
            />
            :
            <ShowBundle
              {...this.state} 
              close={()=>this.props.onClose(mode)}
              saveRecipe={()=>this.saveRecipe()}
              nextBundleStep={()=>this.nextBundleStep()}
              backBundleStep={()=>this.backBundleStep()}
              selMealRcp={(bunIndex)=>this.selMealRcp(bunIndex)}
            />
          }
          <div className="rcp-cal">
            {
              dayDates.length > 0 &&
            (hoverIndex > -1 ? 
              this.cookSchdule()
              :
              this.bundleCookSchdule())
            }
          </div>
          { !bundleStep &&
          <div className="plan-hdng">
            <b> {mealText} meal plan</b>
            <span>Hover and add to build your meal plan</span>
          </div>
          }
          { !bundleStep &&
          <div className="rcp-cal">
            {
              dayDates.length > 0 &&
            mealArr.map((item, mealIndex)=>
              <div className="rcp-typ" key={item.type}>
                {
                  dayDates.map((day, index)=>{
                    const activeDate = `${day.date}-${day.Month}-${day.Year}` 
                    const brdrClass = index === 0 ? "no-brdr": ""
                    const dayDate = `${day.Year}-${day.Month}-${day.date}`
                    const rcpIndex = item.recipe.findIndex(x=>x.meal_date === dayDate )
                    return(
                      <div className="day-range" key={activeDate}>
                       
                        <div className={`cook-sch-cls typ-rcp ${brdrClass}`}>
                          <div className="typ-rcp">
                            { index === 0 && <span className="side-rcp-hdng"> {item.type} </span> }
                            { rcpIndex === -1 ?
                              planIndex !== `${mealIndex}${index}` &&
                              <div className="add-hr-btn">
                                <button className="cook-day" onClick={()=>this.addMeal(mealIndex,dayDate)}>
                                  <img src="/images/add-small.svg" alt=""/>
                                  <span>Add Here</span>
                                </button>
                              </div>
                              :
                              this.mealRcp(mealIndex, rcpIndex, index)
                            }

                          </div>
                        </div>
                        
                      </div>
                    )
                  }
                  )
                }
              </div>
            )
           
            }
          </div>
          }
        </div>
      </div>
    )
  }
}

export default ViewSelectedRecipe;


// WEBPACK FOOTER //
// ./src/components/recipeList/ViewSelectedRecipe.js